import { fromExtendedJsonString } from 'cross-state';
import localforage from 'localforage';

/** Reads what a schummar-state `StorePersist` saved in `localforage.createInstance({ name })` and removes it. */
export async function takeSchummarPersisted(name: string): Promise<Record<string, unknown> | undefined> {
    const storage = localforage.createInstance({ name });
    const keys = (await storage.keys()).sort((a, b) => a.length - b.length);
    if (keys.length === 0) return undefined;

    let result: Record<string, unknown> = {};
    let found = false;
    for (const key of keys) {
        const raw = await storage.getItem<string>(key);
        if (!raw || raw === 'undefined') continue;

        let value: unknown;
        try {
            value = fromExtendedJsonString(raw);
        } catch {
            continue;
        }

        found = true;
        if (key === '') {
            if (value instanceof Object) result = value as Record<string, unknown>;
            continue;
        }

        const path = key.split('.');
        let target = result;
        for (const part of path.slice(0, -1)) {
            if (!(target[part] instanceof Object)) target[part] = {};
            target = target[part] as Record<string, unknown>;
        }
        target[path.at(-1)!] = value;
    }

    await storage.clear();
    return found ? result : undefined;
}
